import { useMutation } from '@tanstack/react-query'
import { jobDescriptionApi } from '@/services/jobDescriptions/jobDescriptions'
import { ReactToJobDescriptionPayload } from '@/interfaces/reaction'

export const useReactToJobDescription = () => {
  return useMutation({
    mutationFn: (payload: ReactToJobDescriptionPayload) =>
      jobDescriptionApi.reactToJobDescription(payload),
  })
}
